import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelReportsFxExecutionsResolverErrorStatesEnum {
    GetTradingGroupsFailed = ErrorStateScheduleEnum.PanelReportsFxExecutionsResolverErrorStatesStartIndex,
    GetPreviousNonWorkingDayFailed,
    GetCurrencyListFailed,
    GetGroupCurrencyListFailed

}
